import { combineReducers } from "@reduxjs/toolkit";
import { reducer as vacationRentalAvailability } from "../modules/availability/reducer";
import { reducer as vacationRentalSearch } from "../modules/search/reducer";
import { reducer as vacationRentalShop } from "../modules/shop/reducer";
import { reducer as vacationRentalRewards } from "../modules/rewards/reducer";
import { reducer as vacationRentalBook } from "../modules/book/reducer";
import { reducer as vacationRentalTravelWallet } from "../modules/travel-wallet/reducer";
import { wishlistsApi, spreedlyCredentialsApi } from "@capone/common";
import {
  wishlistManagementModalReducer,
  wishlistSnackbarReducer,
} from "halifax";

export const rootReducer = combineReducers({
  vacationRentalAvailability,
  vacationRentalSearch,
  vacationRentalRewards,
  vacationRentalShop,
  vacationRentalBook,
  vacationRentalTravelWallet,
  [wishlistsApi.reducerPath]: wishlistsApi.reducer,
  [spreedlyCredentialsApi.reducerPath]: spreedlyCredentialsApi.reducer,
  wishlistManagementModal: wishlistManagementModalReducer,
  wishlistSnackbar: wishlistSnackbarReducer,
});
